module.exports = __webpack_public_path__ + "img/b-2.1df290b.png";